import investorProfile from './investorProfile'

export * from './investorProfile'
export default investorProfile
